import Vue from "vue";
import { NewsService } from "@/common/api.service";
import {
  FETCH_NEWS,
  FETCH_NEWS_DETAIL,
  FETCH_NEWS_RELATES,
  RESET_NEWS_STATE,
  FETCH_NEWS_BY_CATEGORY,
  FETCH_SUPPORTS,
  FETCH_SERVICES
} from "./actions.type";
import {
  FETCH_START,
  FETCH_END,
  SET_NEWS,
  SET_NEWS_DETAIL,
  SET_NEWS_RELATES,
  RESET_STATE,
  SET_NEWS_BY_CATEGORY,
  SET_SUPPORTS,
  SET_SERVICES
} from "./mutations.type";

const initNews = [
  {
    "image": "", 
    "title": 0, 
    "description": ""
  },
  {
    "image": "", 
    "title": 0, 
    "description": ""
  },
  {
    "image": "", 
    "title": 0, 
    "description": ""
  },
  {
    "image": "", 
    "title": 0, 
    "description": ""
  },
  {
    "image": "", 
    "title": 0, 
    "description": ""
  },
  {
    "image": "", 
    "title": 0, 
    "description": ""
  },
  {
    "image": "", 
    "title": 0, 
    "description": ""
  },
  {
    "image": "", 
    "title": 0, 
    "description": ""
  },
  {
    "image": "", 
    "title": 0, 
    "description": ""
  },
  {
    "image": "", 
    "title": 0, 
    "description": ""
  },
  {
    "image": "", 
    "title": 0, 
    "description": ""
  },
  {
    "image": "", 
    "title": 0, 
    "description": ""
  },
];

export const initialState = {
  news: [],
  newsDetail: { title : '', description: ''},
  relateNews: [],
  isLoading: true,
  newsByCategory: [],
  supports: initNews,
  services: [
    {
      "image": "", 
      "title": 0, 
      "description": ""
    },
    {
      "image": "", 
      "title": 0, 
      "description": ""
    },
    {
      "image": "", 
      "title": 0, 
      "description": ""
    }
  ]
};

const state = { ...initialState };

export const getters = {
  isLoading(state) {
    return state.isLoading;
  },
  newsList(state) {
    return state.news;
  },
  newsDetail(state) {
    return state.newsDetail;
  },
  relateNews(state) {
    return state.relateNews;
  },
  newsByCategory(state) {
    return state.newsByCategory;
  },
  supports(state) {
    return state.supports;
  },
  services(state) {
    return state.services;
  }
};

export const actions = {
  async [FETCH_NEWS](context) {
    const data = await NewsService.getAll();
    const { result } = data.data;
    context.commit(SET_NEWS, result.items);
  },
  async [FETCH_NEWS_DETAIL](context, newsSlug) {
    const { data } = await NewsService.get(newsSlug);
    context.commit(SET_NEWS_DETAIL, data.result);
  },
  async [FETCH_NEWS_RELATES](context, newsId) {
    const { result } = await NewsService.getRelates(newsId);
    context.commit(SET_NEWS_RELATES, result.items);
    return result.items;
  },
  [RESET_NEWS_STATE](context) {
    context.commit(RESET_STATE);
  },
  async [FETCH_NEWS_BY_CATEGORY](context, category) {
    const data = await NewsService.getByCategory(category);
    const { result } = data.data;
    context.commit(SET_NEWS_BY_CATEGORY, result.items);
  },
  async [FETCH_SUPPORTS](context) {
    const data = await NewsService.getByCategory('cam-nang-tu-van');
    const { result } = data.data;
    context.commit(SET_SUPPORTS, result.items);
  },
  async [FETCH_SERVICES](context) {
    const data = await NewsService.getByCategory('dich-vu');
    const { result } = data.data;
    context.commit(SET_SERVICES, result.items);
  },
};

export const mutations = {
  [FETCH_START](state) {
    state.isLoading = true;
  },
  [FETCH_END](state) {
    state.isLoading = false;
  },
  [SET_NEWS](state, news) {
    state.news = news;
  },
  [SET_NEWS_DETAIL](state, newsDetail) {
    state.newsDetail = newsDetail;
  },
  [SET_NEWS_RELATES](state, newsRelates) {
    state.relateNews = newsRelates;
  },
  [SET_NEWS_BY_CATEGORY](state, news) {
    state.newsByCategory = news;
  },
  [SET_SUPPORTS](state, news) {
    state.supports = news;
  },
  [SET_SERVICES](state, news) {
    state.services = news;
  },
  [RESET_STATE]() {
    for (let f in state) {
      Vue.set(state, f, initialState[f]);
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
